import React from 'react'

import './Box.scss'
import BigButton from '../button/BigButton'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import date from '../../assets/img/date_w.svg'
import time from '../../assets/img/time_w.svg'
import Webinar from '../ModalPopup/webinarPopup'
const WebinarBannerBox = props => {
  const { imgUrl, headerData } = props
  const [display, setDisplay] = React.useState(false)
  const open = () => {
    if (window !== 'undefined') {
      setDisplay(true)
      document.body.style.overflow = 'hidden'
    }
  }
  const close = () => {
    setDisplay(false)
    document.body.style.overflow = 'unset'
  }



  const renderNormalImage = () => {
    return <img src={imgUrl} alt="..." className="image" />
  }

  const renderGatsbyImg = () => {
    const image = getImage(imgUrl.localFile)
    return <GatsbyImage image={image} className="image" />
  }

  const renderImage = () => {
    if (imgUrl && imgUrl.localFile) {
      return renderGatsbyImg()
    }
    return renderNormalImage()
  }

  return (
    <>
    {display && <Webinar 
    subject='Webinar'
    close={close} /> }
    
    <div className='webinar_header_container'>
      <div className="webinar_webinar_grid">
        <div className="webinar_left" data-aos="fade-right"
            data-aos-delay="800">
          <div className="webinar_topic text-white">
            <span>Webinar Topic:- </span>
            <span>SaaS vs In-House Platforms: Choosing the Right Cards System for Future Growth</span>
          </div>
          <div className="webinar_topic text-white">
            <span>Description:- </span>
            <span>
            This exclusive webinar is designed for CXOs, technology leaders, and card practitioners to explore key decision-making factors, business impact, and future trends in card processing.
            </span>
          </div>
          <div className="webinar_schedule_datetime text-white">
            <div className="webinar_date font-weight-bold text-white">
              <span>Date:- </span>
              <span>12<sup>th</sup> Feb 2025</span>
            </div>
            <div className="webinar_date font-weight-bold text-white">
              <span>Time:- </span>
              <span>{headerData.time}</span>
            </div>
          </div>
          <div>
            <BigButton className="button blue_btn" btnText="Register" click={open} />
          </div>
        </div>
        <div className="webinar_right"
        data-aos="fade-left"
            data-aos-delay="800"
        >
          <div className="webinar_thumbnail">
            <span>{renderImage()}</span>
            <div className="webinar_webinar_detail">
              <div className="webinar_details">
                <div className="webinar_details_icon">
                  <span>
                    <img src={date} className="icon" />
                  </span>
                </div>
                <div className="text-white">12<sup>th</sup> Feb 2025</div>
              </div>

              <div className="webinar_details">
                <div className="webinar_details_icon">
                  <span>
                    <img src={time} className="icon" />
                  </span>
                </div>
                <div className="text-white">4 PM IST</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  )
}

export default WebinarBannerBox
